<section class="fx-row justify-content-between header-section">
  <h4 class="flex fx-row font-xs margin-0">
    <uni-user-avatar
      [user]="publication.author"
      size="micro">
    </uni-user-avatar>
    <div class="margin-y-auto height-min padding-x-1 sparro-grey-800">
      <uni-user-name [user]="publication.author" [truncateAt]="30" class="font-bolder"></uni-user-name>
      <span class="font-regular">
        added
      </span>
      <span class="font-bolder">
        {{ publication.publication_type?.name }}
      </span>
    </div>  
  </h4>
  <div class="flex fx-row-reverse">
    <div fxLayout="row" class="icon-section" fxLayoutAlign="center center">
      <ng-container *ngIf="self || publication.status == 'PUBLISH'">
        <button mat-icon-button (click)="toggleBookmark()" matTooltipPosition="above" *ngIf="publication.status == 'PUBLISH'"
          matTooltip="{{ publication.bookmark ? 'Remove from collection' : 'Add to collection' }}">
          <mat-icon [class]="'icon-add-to-collection '+ (publication?.bookmark ? 'sparro-orange-600' : 'sparro-grey-800')"></mat-icon>
        </button>
        <ng-container *ngIf="showCardOptions">
          <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-wrapper">
            <mat-icon class="icon-three-vertical-dots-fill"></mat-icon>
          </button>
        </ng-container>
        <mat-menu #menu="matMenu" xPosition="before">
          <button mat-menu-item (click)="editPublication()" *ngIf="self">
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="deletePublication()" *ngIf="self">
            <span>Delete</span>
          </button>
          <button mat-menu-item (click)="openShareDialog()" *ngIf="publication.status == 'PUBLISH'">
            <span>Share</span>
          </button>
          <ng-container *ngIf="!self && user">
            <button mat-menu-item (click)="toggleFollow()">
              <span>{{ publication.is_following ? 'Following' : 'Follow' }}</span>
            </button>
            <button mat-menu-item (click)="createReport()" *ngIf="!publication.report || publication.report?.status !== 'INITIATED'"
              [disabled]="publication.report?.status === 'VERIFIED'">
              <span>{{ publication.report?.status === 'VERIFIED' ? 'Reported' : 'Report' }}</span>
            </button>
            <button mat-menu-item *ngIf="publication.report?.status === 'INITIATED'" (click)="redactReport()">
              <span>Redact</span>
            </button>
          </ng-container>
        </mat-menu>
      </ng-container>
    </div>
  </div>
</section>
